import { http } from '@/services';

export default {
  getProfileList: async function() {
    try {
      return await http.get('perfil/');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  createProfile: async function(profile) {
    try {
      return await http.post('perfil/', profile);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  editProfile: async function(currentProfile) {
    try {
      return await http.put('perfil/', currentProfile);
    } catch (e) {
      return e.response.data;
    }
  },
  deleteProfile: async function(profileId) {
    try {
      return await http.delete(`perfil/${profileId}`);
    } catch (e) {
      console.log(e);
      return e.response.data;
    }
  },
};
